import { Grid, Paper, Tab } from '@material-ui/core';
import { TabContext, TabList } from '@material-ui/lab';
import { useStyles } from '@webapps/styles';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import * as React from 'react';

import theme from '../../theme';
import ProfilName from './profilName';

const {
  images: { PicsPalais },
} = theme;

const MediaDetail = ({ Data, image, infoVitrine, swipIndex }) => {
  const { classes, css, cx, global } = useStyles(styles);

  const [tabValue, setTabValue] = React.useState('1');
  const [morePresent, setMorePresent] = React.useState(false);

  React.useEffect(() => {
    setTabValue('1');
    const element = document.getElementById(swipIndex);
    if (swipIndex && element) element.scrollIntoView();
  }, [swipIndex]);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div>
      <ProfilName image={image} info={infoVitrine} />
      <TabContext value={tabValue}>
        <TabList
          className={classes.tabContainer}
          indicatorColor="default"
          onChange={handleChangeTab}
        >
          <Tab
            classes={{
              root: css({
                background: tabValue === '1' ? 'white' : '#F3F7FF',
                color: tabValue === '1' ? '#152652' : '#5A6DA1',
                fontWeight: tabValue === '1' ? 600 : 400,
                width: '33%',
                border: '1px solid #C0D9FF',
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
              }),
            }}
            className={global.mainTitle}
            label="Tous"
            value="1"
          />
          <Tab
            classes={{
              root: css({
                background: tabValue === '2' ? 'white' : '#F3F7FF',
                color: tabValue === '2' ? '#152652' : '#5A6DA1',
                fontWeight: tabValue === '2' ? 600 : 400,
                width: '33%',
                border: '1px solid #C0D9FF',
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
              }),
            }}
            className={global.mainTitle}
            label="Images"
            value="2"
          />
          <Tab
            classes={{
              root: css({
                background: tabValue === '3' ? 'white' : '#F3F7FF',
                color: tabValue === '3' ? '#152652' : '#5A6DA1',
                fontWeight: tabValue === '3' ? 600 : 400,
                width: '34%',
                border: '1px solid #C0D9FF',
                borderTopLeftRadius: 5,
                borderTopRightRadius: 5,
              }),
            }}
            className={global.mainTitle}
            label="Vidéos"
            value="3"
          />
        </TabList>
      </TabContext>
      <Grid container className={classes.container}>
        {Data.filter(
          (d) =>
            d.type !==
            (tabValue === '1' ? '' : tabValue === '3' ? 'image' : 'video')
        ).map(({ description, label, path, type }, index) => (
          <Grid id={index} key={index} item xs={12}>
            <Paper elevation={0} className={classes.paper}>
              <div className={classes.textContainer}>
                <div className={global.title}>{label}</div>
                {description ? (
                  <>
                    <div
                      className={cx([
                        classes.description,
                        css({
                          '-webkit-line-clamp': morePresent ? 'auto' : '3',
                        }),
                      ])}
                    >
                      {parse(description)}
                    </div>
                    <div
                      style={{ display: 'flex', justifyContent: 'flex-end' }}
                    >
                      {description.length > 200 && (
                        <div
                          onClick={() => setMorePresent(!morePresent)}
                          style={{
                            cursor: 'pointer',
                            textDecoration: 'none',
                            color: '#5A6DA1',
                            width: 'fit-content',
                          }}
                        >
                          {morePresent ? 'Voir moins' : '...voir plus'}
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <div className={cx(global.infoText, classes.description)}>Pas de description</div>
                )}
              </div>
              {type === 'image' ? (
                <div
                  className={cx(
                    classes.img,
                    css({ backgroundImage: `url(${path})` })
                  )}
                />
              ) : (
                <div className={classes.video}>
                  <iframe
                    allowFullScreen
                    frameBorder="0"
                    src={`https://www.youtube.com/embed/${path}`}
                    title="Embedded youtube"
                  />
                </div>
              )}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

const styles = ({ spacing }) => ({
  textContainer: {
    padding: spacing(2),
  },
  img: {
    height: '400px',
    backgroundImage: `url(${PicsPalais})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundColor: 'black',
    backgroundPosition: 'center',
    borderBottomLeftRadius: '11px',
    borderBottomRightRadius: '11px',
    '@media (max-width:768px)': { height: '150px' },
  },
  video: {
    height: '400px',
    '& > *': {
      height: '100%',
      width: '100%',
      borderBottomLeftRadius: '11px',
      borderBottomRightRadius: '11px',
    },
    '@media (max-width:768px)': { height: '150px' },
  },
  description: {
    color: '#152652',
    lineHeight: 1.5,
    wordBreak: 'break-word',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '-webkit-box-orient': 'vertical',
    display: '-webkit-box',
    marginBottom: spacing(2),
  },
  container: {
    backgroundColor: '#F3F7FF',
    borderRadius: '0px 0px 10px 10px',
    margin: 0,
    width: '100%',
    padding: '20px',
    rowGap: '30px',
  },
  tabContainer: {
    width: '100%',
    marginTop: spacing(2),
  },
  paper: {
    width: '100%',
    borderRadius: '11px',
    outline: '1px solid #C0D9FF',
  },
});

MediaDetail.propTypes = {
  Data: PropTypes.array,
  infoVitrine: PropTypes.array,
  image: PropTypes.string,
  swipIndex: PropTypes.string,
};

export default MediaDetail;
